export enum OnboardingStep {
  REVIEW_SETTINGS = 'REVIEW_SETTINGS',
  UPLOAD_EMPLOYEES = 'UPLOAD_EMPLOYEES',
  SCHEDULE_ASSIGNMENT = 'SCHEDULE_ASSIGNMENT',
  REVIEW_ASSIGNMENT = 'REVIEW_ASSIGNMENT',
}

export enum OnboardingStepStatus {
  ASSIGNED = 'ASSIGNED',
  COMPLETED = 'COMPLETED',
}

export enum OnboardingTooltipType {
  CONFIGURE_NOTIFICATIONS = 'CONFIGURE_NOTIFICATIONS',
  HELP = 'HELP',
  SCHEDULE_ASSIGNMENT = 'SCHEDULE_ASSIGNMENT',
}

export interface IAdminOnboardingStep {
  type: OnboardingStep;
  status: OnboardingStepStatus;
}

export interface IAdminOnboardingInfo {
  onboardingSteps: IAdminOnboardingStep[];
  isOnboardingComplete: boolean;
}
